import { palette } from '@dev/ee-components';
import styled from 'styled-components';

export type StyledProps = {
    isAutoresponder?: boolean;
};

export type TooltipStyledProps = {
    isAbCampaign?: boolean;
};

export const ToggleWrapper = styled.div`
    margin-top: 26px;
    display: flex;
    height: 28px;
    align-items: flex-end;
`;

export const RadioOptionWrapper = styled.div<StyledProps>`
    display: flex;
    align-items: flex-end;
    margin-top: ${({ isAutoresponder }): number => (isAutoresponder ? 25 : 0)}px;
`;

export const InputsWrapper = styled.div<StyledProps>`
    display: flex;
    gap: 8px;
    align-items: center;
    margin-left: ${({ isAutoresponder }): number => (isAutoresponder ? -60 : 0)}px;

    .inputWrapperBasicInput {
        width: 130px;
    }
`;

export const SectionWrapperStep3 = styled.div`
    padding: 24px 0 32px;
    border-bottom: 1px solid ${palette.gray[3]};
    display: flex;
    flex-direction: column;
    &:last-child {
        border-bottom: none;
    }

    fieldset {
        .MuiFormControlLabel-label {
            font-weight: 600;
            color: ${palette.jacarta[5]};
        }
    }
`;

export const TrackingSectionWrapper = styled(SectionWrapperStep3)`
    padding-bottom: 0;
`;

export const CampaignNameSectionWrapper = styled(SectionWrapperStep3)`
    padding-top: 0;
`;

export const TooltipIconWrapper = styled.div<TooltipStyledProps>`
    display: flex;
    margin-left: ${({ isAbCampaign }): number => (isAbCampaign ? 4 : 8)}px;
    svg {
        fill: ${palette.gray[4]};
    }
`;

export const IconInfoWrapper = styled.div`
    margin-right: 16px;
    svg {
        fill: ${palette.blue[4]};
    }
`;


export const SendToStepTitleWrapper = styled.div`
    display: inline-flex;
    align-items: center
`

export const AlertWrapper = styled.div`
    margin-top: 16px;

    .MuiAlert-root {
        margin-bottom: 0;
    }
    &.alert-text-justify-between {
        .MuiAlert-message {
            width: 100%;
        }
        .typography-text-box {
            display: flex;
            justify-content: space-between;
        }
    }
`;